(function () {
    'use strict';

    angular
        .module('ib-web-ancillaries-services-module')
        .service('AncillariesMealsService', AncillariesMealsService);

    AncillariesMealsService.$inject = ['$q', 'CommonsAncillariesService', 'AncillariesUtilsService', 'localStorageService', '$rootScope', 'ModalServiceAncillaries', 'CallAncillariesPageService'];
    function AncillariesMealsService ($q, CommonsAncillariesService, AncillariesUtilsService, localStorageService, $rootScope, ModalServiceAncillaries, CallAncillariesPageService) {

        const self = this;
        self.mealsByPassenger = [];
        self.loadMealsByPassenger = loadMealsByPassenger;
        self.mealsSelected = mealsSelected;
        self.addMealByPassenger = addMealByPassenger;
        self.isClosed = isClosed;
        self.updatePassengersMeals = updatePassengersMeals;
        self.dataUpdateMeals;

        /**
         * Load all current meals in order
         */
        function loadMealsByPassenger () {
            return self.mealsByPassenger;

        }

        /**
         * Return true if meals is edited
         */
        function mealsSelected () {
            return self.mealsByPassenger && self.mealsByPassenger.length > 0;
        }

        /**
         * Add a new Meal in array
         */
        function addMealByPassenger (meal) {
            self.mealsByPassenger.push(meal);
        }

        /**
         * Check if is closed the process of edit meals
         */
        function isClosed (ancillaries) {
            let closed = true;
            if(ancillaries && ancillaries.segments) {
                for(let indexSegment = 0; indexSegment < ancillaries.segments.length; indexSegment++) {
                    const segment = ancillaries.segments[indexSegment];
                    if(segment.status.code === 'AVAILABLE') {
                        closed = false;
                    }
                }
            }
            return closed;
        }

        /**
         * Send information of seat map
         * @param {*} updateSeatsInfo
         * @param {*} currency
         */
        function updatePassengersMeals (updatedMeals, flowId) {
            const deferred = $q.defer();
            if (lengthOfObject(updatedMeals).length > 0) {
                const specialMealsCopy = localStorageService.get('specialMealsCopy');
                const dataMeal = AncillariesUtilsService.generateUpdateSpecialMeals(updatedMeals, specialMealsCopy);
                self.dataUpdateMeals = dataMeal;
                localStorageService.set('specialMealsTempInfo', updatedMeals);
                if(dataMeal.update[0].segments.length > 0) {
                    ModalServiceAncillaries.showWaitingModal();
                    CommonsAncillariesService.updateAncillaries(dataMeal.update).then(updatePassengersMealsSuccess, passengersMealsError);
                } else if(dataMeal.update[0].segments.length === 0 && dataMeal.delete[0].segments.length > 0) {
                    ModalServiceAncillaries.showWaitingModal();
                    CommonsAncillariesService.deleteAncillarie(dataMeal.delete).then(deleteMealsSuccess, passengersMealsError);
                }

            } else {
                deferred.resolve();
            }
            return deferred.promise;

            function updatePassengersMealsSuccess (data) {
                if(self.dataUpdateMeals.delete[0].segments.length > 0) {
                    CommonsAncillariesService.deleteAncillarie(self.dataUpdateMeals.delete).then(deleteMealsSuccess, passengersMealsError);
                } else {
                    updateSpecialMeals();
                }
                deferred.resolve(data);
            }
            function deleteMealsSuccess (data) {
                updateSpecialMeals();
            }

            function passengersMealsError (error) {
                const errorDetails = error.data && error.data.errors ? error.data.errors[0] : {};
                const isUnexpectedError = errorDetails.reason === 'UNEXPECTED_TECHNICAL_EXCEPTION';
                const errorObject = {
                    message: isUnexpectedError ? 'REST_SERVICE_ERROR_UNEXPECTED' : errorDetails.reason || 'REST_SERVICE_ERROR_UNEXPECTED',
                    needsTranslate: !isUnexpectedError,
                    internalErrorCode: errorDetails.code
                };

                ModalServiceAncillaries.isNotWaiting();
                ModalServiceAncillaries.showGenericError(errorObject).result.then(angular.noop, angular.noop);
                deferred.reject(error);
            }

            function lengthOfObject (meals) {
                return Object.values(meals);
            }

            function updateSpecialMeals () {
                let propSegment, propPassenger;
                const arrSpecialMeal = [];
                const specialMeal = localStorageService.get('specialMealsTempInfo');
                for (propSegment in specialMeal) {
                    for (propPassenger in specialMeal[propSegment].passengers) {
                        arrSpecialMeal.push({
                            segmentId: propSegment,
                            id: specialMeal[propSegment].passengers[propPassenger].id,
                            infant: specialMeal[propSegment].passengers[propPassenger].infant,
                            menu: specialMeal[propSegment].passengers[propPassenger].menu,
                            menudesc: specialMeal[propSegment].passengers[propPassenger].menudesc,
                            name: specialMeal[propSegment].passengers[propPassenger].name,
                            surname: specialMeal[propSegment].passengers[propPassenger].surname,
                            nameInfant: specialMeal[propSegment].passengers[propPassenger].nameInfant,
                            surnameInfant: specialMeal[propSegment].passengers[propPassenger].surnameInfant
                        });
                    }
                }
                localStorageService.set('specialMealsTempInfoAux', arrSpecialMeal);
                ModalServiceAncillaries.closeWaitingModal();
                $rootScope.$broadcast('updateSpecialMeals');
            }
        }
    }
})();
